// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";

function VoucherDisplay(props) {
  let match = React.useState(() => false);
  let setOpenModal = match[1];
  let match$1 = React.useState(() => "");
  let setReturnUrl = match$1[1];
  let returnUrl = match$1[0];
  let match$2 = React.useState(() => "");
  let setDownloadUrl = match$2[1];
  let match$3 = React.useState(() => "");
  let setReference = match$3[1];
  let logger = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let match$4 = React.useState(() => 0);
  let setDownloadCounter = match$4[1];
  let downloadCounter = match$4[0];
  let match$5 = React.useState(() => "");
  let setPaymentMethod = match$5[1];
  let paymentMethod = match$5[0];
  let match$6 = React.useState(() => null);
  let setPaymentIntent = match$6[1];
  let paymentIntent = match$6[0];
  let match$7 = React.useState(() => true);
  let setLoader = match$7[1];
  let loader = match$7[0];
  let linkRef = React.useRef(null);
  React.useEffect(() => {
    let link = linkRef.current;
    if (!(link == null)) {
      link.click();
    }
  }, [loader]);
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
        return;
      }
      let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
      let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
      setReturnUrl(param => Utils$OrcaPaymentPage.getString(metaDataDict, "returnUrl", ""));
      setDownloadUrl(param => Utils$OrcaPaymentPage.getString(metaDataDict, "voucherUrl", ""));
      setReference(param => Utils$OrcaPaymentPage.getString(metaDataDict, "reference", ""));
      setPaymentMethod(param => Utils$OrcaPaymentPage.getString(metaDataDict, "paymentMethod", ""));
      setPaymentIntent(param => Utils$OrcaPaymentPage.getJsonObjectFromDict(metaDataDict, "payment_intent_data"));
      setLoader(param => false);
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  let closeModal = () => {
    Utils$OrcaPaymentPage.postSubmitResponse(paymentIntent, returnUrl);
    Modal$OrcaPaymentPage.close(setOpenModal);
  };
  return JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("p", {
              children: [
                Utils$OrcaPaymentPage.snakeToTitleCase(paymentMethod) + ` voucher was successfully generated! If the document hasn't started downloading automatically, click `,
                JsxRuntime.jsx("a", {
                  children: "here",
                  ref: Primitive_option.some(linkRef),
                  className: "text font-medium text-sm text-[#006DF9] underline",
                  href: match$2[0],
                  onClick: param => {
                    setDownloadCounter(c => c + 1 | 0);
                    LoggerUtils$OrcaPaymentPage.handleLogging(logger, downloadCounter.toString(), "DISPLAY_VOUCHER", paymentMethod, undefined);
                  }
                }),
                " to download it."
              ],
              className: "Disclaimer font-medium text-sm text-[#151A1F] opacity-70"
            }),
            className: "flex flex-row w-full"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("p", {
              children: [
                "Bar Code Reference: ",
                JsxRuntime.jsx("span", {
                  children: match$3[0],
                  className: "Disclaimer font-bold text-sm text-[#151A1F] opacity-90"
                })
              ],
              className: "Disclaimer font-medium text-sm text-[#151A1F] opacity-70"
            }),
            className: "flex flex-row mt-4 w-full"
          }),
          JsxRuntime.jsx("div", {
            children: "Please do not close until you have successfully downloaded the voucher, after which you will be automatically redirected.",
            className: "Disclaimer w-full mt-16 font-medium text-xs text-[#151A1F] opacity-50"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("button", {
                children: "Done",
                className: "w-full mt-6 p-2 h-[40px]",
                style: {
                  background: "#006DF9",
                  borderRadius: "4px",
                  color: "#ffffff"
                },
                onClick: param => closeModal()
              })
            }),
            className: "button w-full"
          })
        ],
        className: "flex flex-col max-w-md justify-between items-center"
      }),
      className: "flex flex-col h-full justify-between items-center"
    }),
    loader: loader,
    showClose: false,
    setOpenModal: setOpenModal,
    openModal: match[0]
  });
}

let make = VoucherDisplay;

export {
  make,
}
/* jotai Not a pure module */
